import "../css/main.scss";
import { BtixConstant } from "./constant";
import { activateLeftNaviSubMenu } from "./module/left-submenu";
import { initAuthButtons } from "./auth";
import { initDxpoSuppliers } from "./pages/dxpo/supplier";
import { initModalControl } from "./module/modal";
import { initMyPageChat } from "./pages/mypage/chat";
import { initMyPageConnect } from "./pages/mypage/connect";
import { initPortalWebinarSearch } from "./pages/portal/webinar/search";
import { initSampleSeriesWeboothTop } from "./pages/sample-series/webooth/top";
import { initSampleSeriesConsideration } from "./pages/sample-series/consideration";
import { initSampleSeriesRegistrationAndSignup } from "./pages/sample-series/registration-and-signup";
import { initSampleSeriesWeboothCategory } from "./pages/sample-series/webooth/category";
import { initSampleSeriesWeboothDetail } from "./pages/sample-series/webooth/detail";
import { initSampleSeriesWeboothDownload } from "./pages/sample-series/webooth/download";
import { initSampleSeriesWeboothEstimate } from "./pages/sample-series/webooth/estimate";
import { initSampleSeriesWeboothSearch } from "./pages/sample-series/webooth/index";
import { initWebinarSearch } from "./pages/sample-series/webinar/search";
import { initWebinarDetail } from "./pages/sample-series/webinar/detail";
import { reservationCalendarModal } from "./pages/reservation/reservation-calendar";
import { initReservationDetail } from "./pages/reservation/reservation-detail";
import { seminerApplication } from "./pages/seminar-application/index";
import { initMypageBusinessCardIndex } from "./pages/mypage/business-card/index";
import { initMyPageWebinarFavorite } from "./pages/mypage/webinar/favorite/index";
import { initInformation } from "./pages/mypage/information";
import { initConfirmPage } from "./module/confirm-page";
import { initSideMenuChat } from "./module/side-menu-chat";
import { initOnlineRegistrationForm } from "./pages/sample-series/online-registration/form";
import { initRealEventBadgePrint } from "./pages/real-events/print-badge";
import { initConfirmRegistrationAndSignup } from "./pages/sample-series/registration-and-signup/confirm";
import { initLoadinglControl } from "./module/loading";
import { initSelectBox } from "./module/selectbox";
import { initVisitorSeminarApplicationIndex } from "./pages/visitor/seminar-application";
import { initVisitorReservationIndex } from "./pages/visitor/reservation";
import { initSampleSeriesConnectConciergeForm } from "./pages/sample-series/components/concierge";
import { initVipCodeArea } from "./pages/tokyo/registration/form";
import { initRegistrationForVip } from "./pages/registration/vip-code";
import { initMypageUpdateUnReadCount } from "./pages/mypage/mypage";
import { initTopUpdateUnReadCount } from "./top";
import { initMyPageConnectDetail } from "./pages/mypage/connect/detail";
import { validateVipCodeInput } from './validate-vip-code';
Window.BtixConstant = BtixConstant;
window.validateVipCodeInput = validateVipCodeInput;
// ==========================================
// システム全体の初期化
window.addEventListener("load", () => {
    window.console.log("Initialize...");
    //下の箇所でエラーが出ていて検証できないため一時的に挿入
    seminerApplication(); //ビジターのセミナー申込画面
    initInformation(); // お知らせ一覧の初期化
    initConfirmPage(); // 確認ページ表示用
    initSideMenuChat();
    initOnlineRegistrationForm(); // オンライン会員登録画面初期化
    // ここは優先的に初期化すべきもの
    initSelectBox(); // セレクトボックスの初期化
    initModalControl(); // モーダルビュー周りの初期化
    initLoadinglControl(); // ローディングコントロール差し込み用
    // 優先度：中
    initSampleSeriesConnectConciergeForm(); //Connectコンシェルジュへの相談フォーム画面の初期化
    initSampleSeriesWeboothTop(); //シリーズトップ画面（オンライン展）の初期化
    initSampleSeriesWeboothCategory(); //商品カテゴリー一覧画面の初期化
    initSampleSeriesWeboothDetail(); //Webooth詳細周りの初期化
    initSampleSeriesWeboothDownload(); //webooth資料をもらう周りの初期化
    initSampleSeriesWeboothEstimate(); //Webooth見積を依頼する周りの初期化
    initSampleSeriesConsideration(); //出展をご検討中の方へ 画面の初期化
    initSampleSeriesRegistrationAndSignup(); //リアル展示会_来場事前登録兼会員情報登録画面の初期化
    initWebinarSearch(); //Webinar検索画面の初期化
    initWebinarDetail(); //Webinar詳細画面の初期化
    initDxpoSuppliers(); //リアル展示会_出展社_一覧画面の初期化
    initPortalWebinarSearch(); //シリーズ横断セミナー検索・一覧画面の初期化
    initMyPageChat(); //マイページ チャット一覧画面の初期化
    initMyPageConnect(); //シリーズ横断Connect提案依頼一覧画面の初期化
    initMyPageConnectDetail(); //シリーズ横断Connect提案依頼詳細画面の初期化
    reservationCalendarModal(); //商談予約ページのモーダル
    initReservationDetail(); // 商談予約詳細ページの初期化
    initMypageBusinessCardIndex(); // マイページ名刺交換一覧の初期化
    initSampleSeriesWeboothSearch(); // Webooth検索画面
    initMyPageWebinarFavorite(); // Webinarお気に入り一覧の初期化
    initVisitorSeminarApplicationIndex(); //専門セミナー/特別企画受講申込画面の初期化
    initVisitorReservationIndex(); //展示会商談予約カレンダーの初期化
    initRealEventBadgePrint(); //リアル展示会来場者バッジ印刷の初期化
    initConfirmRegistrationAndSignup(); // 来場登録兼会員登録の確認画面の初期化
    initVipCodeArea(); // 来場登録と会員登録を兼ねるページで使用するVIP関係
    initRegistrationForVip(); // 来場者登録単体で使用するVIP関係
    initMypageUpdateUnReadCount(); // マイページボタン押下後のチャット新着件数の初期化
    initTopUpdateUnReadCount(); // ログインボタン押下後のチャット新着件数の初期化
    // ここから下は初期化時に遅れても問題ないもの
    initAuthButtons(); // ログイン/ログアウト周りのボタン初期化
    activateLeftNaviSubMenu(); // 左サブメニューの初期化
});
